import { Box, Button, Container } from "@mui/material";

import { HeroText } from "components/shared/Typography";
import { IDT_REQUEST_CONSULTATION } from "helpers/constants";

export const GeneralInquiry = () => (
  <Box
    component="section"
    pt={{ xs: 4, md: 5, lg: 10 }}
    pb={{ xs: 5, md: 7, lg: 12 }}
    className="default-bg"
  >
    <Container>
      <HeroText align="center" component="h2">
        General inquiry
      </HeroText>
      <Box mt={4} display="flex" width={1} justifyContent="center">
        <Button
          size="large"
          onClick={() => window.open(IDT_REQUEST_CONSULTATION, "_blank")}
        >
          Go to form
        </Button>
      </Box>
    </Container>
  </Box>
);
